;(function () {
  'use strict'

  angular
    .module('contrast.settings.groups')
    .factory(
      'groupsApiConfig',
      function groupsApiConfigFactory($http, $q, UserService) {
        'ngInject'

        return {
          getQuickFilters: getQuickFilters,
          getGroups: getGroups,
          getGroupsBase: getGroupsBase,
          checkName: checkName,
          checkNameUpdate: checkNameUpdate,
          getGroup: getGroup,
          createGroup: createGroup,
          updateGroup: updateGroup,
          deleteGroup: deleteGroup
        }

        function getQuickFilters(filterText) {
          var httpTimeout = $q.defer()

          var request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/groups/filters/quick'),
            params: {
              filterText: filterText
            },
            timeout: httpTimeout.promise
          })

          request._httpTimeout = httpTimeout
          return request
        }

        function getGroups(
          expand,
          limit,
          offset,
          searchKey,
          sortRow,
          quickFilter
        ) {
          var httpTimeout = $q.defer(),
            request = $http({
              method: 'get',
              url: UserService.buildAPIUrl('/groups'),
              params: {
                limit: limit,
                offset: offset,
                q: searchKey,
                sort: sortRow,
                expand: expand,
                quickFilter: quickFilter
              },
              timeout: httpTimeout.promise
            })

          request._httpTimeout = httpTimeout
          return request
        }

        function getGroupsBase() {
          return $http
            .get(UserService.buildAPIUrl('/groups'), {
              params: { base: true }
            })
            .then(function (response) {
              var data = response.data
              // remove `rbac_controlled` group
              var groups = data.groups.filter(function (group) {
                return !group.name.includes('rbac_controlled')
              })
              var cleanData = Object.assign({}, data, { groups })
              return { data: cleanData }
            })
        }

        function checkName(name) {
          return $http.post(UserService.buildAPIUrl('/groups/unique'), {
            name: name
          })
        }

        function checkNameUpdate(id, name) {
          return $http.post(
            UserService.buildAPIUrl('/groups/' + id + '/unique'),
            { name: name }
          )
        }

        function getGroup(id) {
          return $http.get(UserService.buildAPIUrl('/groups/' + id))
        }

        function createGroup(request) {
          return $http.post(UserService.buildAPIUrl('/groups'), request)
        }

        function updateGroup(id, request) {
          return $http.put(UserService.buildAPIUrl('/groups/' + id), request)
        }

        function deleteGroup(id) {
          return $http['delete'](UserService.buildAPIUrl('/groups/' + id))
        }
      }
    )
})()
